import React from 'react';
import { Fade, Slide, H2, Copy, Optional } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import styled from 'styled-components';
import css from '@styled-system/css';
import { styledCompiler, getTitleComponent, stripMarkdownHeading } from '../../utils/markdown';

const StyledCopy = styled(Copy)(
  css({
    a: {
      color: 'primary',
      textDecoration: 'none',
      fontWeight: 'bold',
      pointerEvents: 'auto',
    },
  }),
);

const Hero = ({
  title,
  subtitle = '',
  bodyText,
  seoH1 = '',
  shouldSlide,
  slideDirection,
  slideDistance,
  slideIn,
  shouldFade,
  fadeDirection,
  initialOpacity,
  delay,
  isDark,
  isActive,
}) => {
  const TitleComponent = getTitleComponent(title, H2);

  return (
    <>
      <Slide
        shouldAnimate={shouldSlide}
        direction={slideDirection}
        distance={slideDistance}
        delay={delay && `${delay}s`}
        slideIn={slideIn}
        pointerEvents={isActive ? 'auto' : 'none'}
      >
        <Fade
          shouldAnimate={shouldFade}
          direction={fadeDirection}
          initialOpacity={initialOpacity}
          delay={delay && `${delay}s`}
          pointerEvents={isActive ? 'auto' : 'none'}
        >
          {/* SEO h1 */}
          <TitleComponent
            data-testid="title"
            textAlign="center"
            mb="m"
            style={{ textTransform: 'none' }}
            as={seoH1 === 'Title' && 'h1'}
            color={isDark ? 'white' : 'black'}
          >
            {styledCompiler(stripMarkdownHeading(title))}
          </TitleComponent>
          <Optional when={subtitle}>
            <Copy data-testid="subtitle" textAlign="center" mb="m" as={seoH1 === 'Subtitle' && 'h1'}>
              {compiler(stripMarkdownHeading(subtitle))}
            </Copy>
          </Optional>
        </Fade>
      </Slide>
      <Slide
        shouldAnimate={shouldSlide}
        direction={slideDirection}
        distance={slideDistance}
        delay={delay && `${delay + 0.2}s`}
        slideIn={slideIn}
        pointerEvents={isActive ? 'auto' : 'none'}
      >
        <Fade
          shouldAnimate={shouldFade}
          direction={fadeDirection}
          initialOpacity={initialOpacity}
          delay={delay && `${delay + 0.2}s`}
          pointerEvents={isActive && 'auto'}
        >
          <StyledCopy
            fontSize={['14px', '16px']}
            lineHeight={['22px', '26px']}
            mt="m"
            color={isDark ? 'white' : 'black'}
            as={seoH1 === 'Description' && 'h1'}
          >
            {bodyText ? compiler(bodyText) : null}
          </StyledCopy>
        </Fade>
      </Slide>
    </>
  );
};

export default Hero;
